import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './BottleGourdPage.css';
import bottlegourdLogo from '../images/bottlegourd-logo.png';
import ashwin from '../images/bottlegourd-ashwini-img.png';
import sitra from '../images/bottlegourd-sitara-img.png';

const varieties = [
  {
    name: 'SITARA',
    image: sitra,
    description: [
      'Very early maturing and early bulker hybrid',
      'Produces long, smooth, parrot green coloured cylindrical fruits',
      'Fetches good market price because of attractive colour',
      'High yield potential',
      'Fruit colour: Parrot green',
      'Fruit shape: Cylindrical',
      'Fruit texture: Smooth',
      'Fruit length: 25-30 cm',
      'Fruit width: 6.5-7.5 cm',
      'Fruit weight: 0.7-0.8 kg',
      'Seed rate: 0.8-1.5 kg per acre',
      'Method of sowing: Dibbling',
      'Spacing: Row to ridge 5-8 ft and plant to plant 2-3 ft',
      'First harvest: 42-47 days',
    ],
  },
  {
    name: 'ASHWIN',
    image: ashwin,
    description: [
      'Recommended for cultivation across Pan India',
      'Suitable for planting during Kharif and Summer seasons',
      'First harvest begins 55-60 days after planting',
      'Fruit weight: 700-800 gm',
      'Fruits are bulb segment type, uniform and tender',
      'Fruit length: 18-20 cm',
      'Fruit width: 12-18 cm',
      'Tolerant to heat and Gummy Stem Blight (GSB)',
    ],
  },

  
];

export default function BottleGourdPage() {
  return (
    <ProductPatternPage
      title="Bottle Gourd"
      varieties={varieties}
      pageClass="bottlegourd-page"
      heroImage={bottlegourdLogo}
    />
  );
}
